// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IZEC","col":"styles_col__3T6jN"};